import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PurchaseProfileService } from '../../purchase-profile.service';

@Component({
  selector: 'app-purchase-profile-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './purchase-profile-banner.component.html',
  styleUrls: ['./purchase-profile-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchaseProfileBannerComponent {
  readonly service = inject(PurchaseProfileService);

  openWizard(): void {
    this.service.openModal(0);
  }
}
